




























import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import useMatchMedia from '@/hooks/useMatchMedia';

interface ISubHeroItem {
  img: string;
  label?: string;
  imageExplainerText: string;
}

export default defineComponent({
  props: {

    backgroundColorVariant: {
      type: String,
    },
    showLastItemOnMobile: {
      type: Boolean,
    },
    items: {
      type: Array as PropType<Array<ISubHeroItem>>,
    },
  },
  setup(props) {
    const matchMedia = useMatchMedia();

    const subHeroItems = computed(() => {
      if (matchMedia.value.sm) {
        return props.items;
      }
      if (props.showLastItemOnMobile) {
        return props.items?.slice(-1);
      }

      return props.items?.slice(0, -1);
    });

    return {
      subHeroItems,
    };
  },
});
